import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=0530ae54&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530ae54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0530ae54')) {
      api.createRecord('0530ae54', component.options)
    } else {
      api.reload('0530ae54', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=0530ae54&scoped=true", function () {
      api.rerender('0530ae54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ResetPassword.vue"
export default component.exports